import { useEffect, useRef, useState, useMemo } from "react";
import api from "../api/axios";
import Sidebar from "../components/SideBar/Sidebar";
import GoogleMapComponent from "../components/Maps/GoogleMapComponent";
import { socket } from "../services/socket";
import DataTable from "react-data-table-component";
import "../styles/MonitorPage.css";

export default function MonitorPage() {
  const [vehiclesTable, setVehiclesTable] = useState([]);
  // const [filteredVehicles, setFilteredVehicles] = useState([]);
  // const [loadingTable, setLoadingTable] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  // const [search, setSearch] = useState("");
  // const [clickedVehicle, setClickedVehicle] = useState(null);
  const [vehiclesReady, setVehiclesReady] = useState(false);
  const activeRowRef = useRef(null);
  let searchTimeout;

  // 🚀 Estado REAL de GPS (NO React)
  const vehiclesRef = useRef(new Map());
  const mapRef = useRef(null);
  const tableRefs = useRef({
    row: new Map(),
    estado: new Map(),
  });

  // ==============================
  // Fetch inicial
  // ==============================
  useEffect(() => {
    fetchVehicles();
  }, []);

  const fetchVehicles = async () => {
    try {
      // setLoadingTable(true);
      const res = await api.get("/vehicles/listGps");
      // const res = await fetch("/mock/vehiculos_mock_3000.json");

      const map = new Map();
      // res.data.data.forEach(v => {
      res.data.data.forEach(v => {
        map.set(v.id, {
          ...v,
          latitude: Number(v.latitude),
          longitude: Number(v.longitude),
        });
      });

      vehiclesRef.current = map;
      setVehiclesReady(true);

      // La tabla NO necesita tiempo real
      // setVehiclesTable(res.data.data);
      setVehiclesTable(res.data.data);
      // setFilteredVehicles(res.data.data);
    } catch (err) {
      console.error(err);
    } finally {
      // setLoadingTable(false);
    }
  };

  useEffect(() => {
    if (!vehiclesReady) return;

    vehiclesRef.current.forEach(v => {
      const rowEl = document.getElementById(`row_${v.id}`);
      const estadoEl = document.getElementById(`estado_${v.id}`);

      if (rowEl) {
        tableRefs.current.row.set(v.id, {
          el: rowEl,
          searchText: (
            `${v.driver_name} ${v.plate} ${v.lateral}`
          ).toLowerCase(),
        });
      }

      if (estadoEl) {
        tableRefs.current.estado.set(v.id, estadoEl);
      }
    });
  }, [vehiclesReady]);

  useEffect(() => {
    if (!vehiclesReady) return;

    const onGpsMonitor = data => {
      const { vehicle_id, lat, lon } = data;
      console.log(vehicle_id, lat, lon);

      const vehicle = vehiclesRef.current.get(vehicle_id);
      if (!vehicle) return;

      // 🔥 Actualizamos SOLO el ref
      vehicle.latitude = Number(lat);
      vehicle.longitude = Number(lon);

      vehiclesRef.current.set(vehicle_id, vehicle);
    };

    const handleTramo = data => {
      console.log("tramos", data);
      const vehicleId = Number(data.vehicle_id);
      const lat = Number(data.lat);
      const lon = Number(data.lon);

      const vehicle = vehiclesRef.current.get(vehicleId);
      if (!vehicle) {
        console.warn(`Vehículo ${vehicleId} no encontrado`);
        return;
      }

      // 🔥 actualización directa (NO React)
      vehicle.latitude = lat;
      vehicle.longitude = lon;
      vehicle.estado = "En Servicio";

      vehiclesRef.current.set(vehicleId, vehicle);

      // Cambiar Estado en la Tabla
      const estadoEl = tableRefs.current.estado.get(vehicleId);
      if (estadoEl) {
        estadoEl.textContent = "En Servicio";
        estadoEl.classList.remove("bg-secondary");
        estadoEl.classList.add("bg-success");
      }
    };
    
    const handleFinViaje = data => {
      console.log('data', data);
      const vehicleId = Number(data.vehicle_id);
      const lat = Number(data.fin_lat);
      const lon = Number(data.fin_lon);

      const vehicle = vehiclesRef.current.get(vehicleId);
      if (!vehicle) {
        console.warn(`Vehículo ${vehicleId} no encontrado`);
        return;
      }

      // 🔥 actualización directa
      vehicle.latitude = lat;
      vehicle.longitude = lon;
      vehicle.estado = "Disponible";

      vehiclesRef.current.set(vehicleId, vehicle);

      // Cambiar Estado en la Tabla
      const estadoEl = tableRefs.current.estado.get(vehicleId);
      if (estadoEl) {
        estadoEl.textContent = "Disponible";
        estadoEl.classList.remove("bg-success");
        estadoEl.classList.add("bg-secondary");
      }
    };

    socket.connect();

    socket.on("connect", () => {
        console.log("Conectado al Socket con Id: ", socket.id);
        socket.emit("subscribe", { id_vehicule: "GPS", id_viaje: "MONITOR" });
    });

    socket.on("disconnect", () => {
        console.log("Socket desconectado");
    });

    socket.on("GPS_MONITOR", onGpsMonitor);

    socket.on("POSICION_TAXI", handleTramo);
    
    socket.on("FIN_VIAJE", handleFinViaje);

    return () => {
        socket.off("connect");
        socket.off("GPS_MONITOR");
        socket.off("disconnect");
        socket.disconnect();
    };
  }, [vehiclesReady]);
  
  // Función para manejar el toggle
  const handleToggle = (newState) => {
      setIsSidebarOpen(newState);
  };

  const handleSearch = (e) => {
    clearTimeout(searchTimeout);
    const value = e.target.value.toLowerCase();

    searchTimeout = setTimeout(() => {
      tableRefs.current.row.forEach(({ el, searchText }) => {
        el.style.display = searchText.includes(value)
          ? ""
          : "none";
      });
    }, 1000);
  };

  const handleOnVehicle = (vehicleId) => {
    // quitar highlight anterior
    if (activeRowRef.current) {
      activeRowRef.current.classList.remove("active-row");
    }

    const rowObj = tableRefs.current.row.get(vehicleId);
    if (!rowObj) return;

    rowObj.el.classList.add("active-row");
    activeRowRef.current = rowObj.el;

    const vehicle = vehiclesRef.current.get(vehicleId);
    console.log("Vehículo seleccionado:", vehicle);

    mapRef.current?.centerToVehicle(vehicleId);
  };

  return (
    <div className="page-layout">
      <div className="sidebar-section">
        <Sidebar 
            initialOpen={isSidebarOpen}
            onToggle={handleToggle}
        >
            {/* Contenido de la barra lateral */}
            {/* TABLA */}
            <div className="px-3 py-4">
              <input
                type="text"
                className="form-control form-control-sm"
                placeholder="Buscar vehículo..."
                onChange={handleSearch}
              />
            </div>
            <div className="table-scroll">
              <table className="table table-striped table-hover table-sm">
                <thead>
                  <tr>
                    <th><h3 className="text-center fs-6">Nombre</h3></th>
                    <th><h3 className="text-center fs-6">Placa</h3></th>
                    <th><h3 className="text-center fs-6">Lateral</h3></th>
                    <th><h3 className="text-center fs-6">Estado</h3></th>
                  </tr>
                </thead>

                <tbody>
                  {vehiclesTable.map(v => (
                    <tr key={v.id} 
                        id={`row_${v.id}`} 
                        className="small align-middle cursor-pointer"
                        onClick={() => handleOnVehicle(v.id)}
                    >
                      <td className="text-center">{v.driver_name}</td>
                      <td className="text-center">{v.plate}</td>
                      <td className="text-center">{v.lateral}</td>
                      <td className="text-center">
                        <span
                          id={`estado_${v.id}`}
                          className="bg-secondary badge"
                        >
                          Disponible
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
        </Sidebar>
      </div>

      {/* Contenido principal - DEBE ESTAR EN EL MISMO DIV PADRE */}
      <main className={`main-content`}>
        <div>
          <GoogleMapComponent
            ref={mapRef}
            vehiclesRef={vehiclesRef}
            vehiclesReady={vehiclesReady}
          />
        </div>
      </main>
      
      {/* <main className={`main-content ${isSidebarOpen ? "sidebar-open" : ""}`}>
        <GoogleMapComponent
          vehiclesRef={vehiclesRef}
          vehiclesReady={vehiclesReady}
        />
      </main> */}
    </div>
  );
}